import { Button, ToastNotification } from "@artis/ui";

import { useProductById } from "../../data";
import { parseAlertLimit } from "../../data/alerts/utils";
import { removeBottomRightToast } from "../components/bottomRightToastStack";
import { useUpdateAlert } from "../../data/alerts";
import type { TAlert } from "../../data/alerts/queries";
import { getAlertDetails } from "./priceAlerts";

export const CellAlertToast = ({ alert, onDismiss }: { alert: TAlert; onDismiss: () => void }) => {
  const parsed = parseAlertLimit(alert.limit);
  const limitProduct = useProductById(parsed.productId);
  const product = useProductById(alert.product_id);
  const updateAlert = useUpdateAlert();

  const formattedMessage = getAlertDetails(
    alert,
    product.data?.name ?? "",
    limitProduct.data?.name ?? "",
    product.data?.packageByPackage?.name,
  );

  return (
    <ToastNotification
      severity="alert"
      title={`${alert.note || "Alert"} triggered`}
      onDismiss={onDismiss}
      data-testid={`alert-toast-${alert.id}`}
      actions={
        alert.recurring ? undefined : (
          <>
            <Button variant="text" color="neutral" size="sm" onClick={onDismiss}>
              Close
            </Button>
            <Button
              variant="outline"
              color="primary"
              size="sm"
              onClick={() => {
                removeBottomRightToast(alert.id);
                // Clearing `triggered_at` hands the alert back to the worker's recede check, so it
                // re-arms once the value moves off the limit rather than firing again instantly.
                updateAlert.mutate({ id: alert.id, triggered_at: null });
              }}
            >
              Repeat Alert
            </Button>
          </>
        )
      }
    >
      {formattedMessage}
    </ToastNotification>
  );
};
